import { appFormUtil } from 'modules';
import React, { useEffect } from 'react';

import {
  useSaveStandardAreaInstallationMutation,
  SaveStandardAreaInstallation_Input,
  useStandardAreaInstallationFormQuery
} from 'generated/graphql';

export type IFormState = {
  displayName: string;
  id: string;
  milestoneId: string;
  areaId: string;
  subAreaId: string;
  typeId: string;
};

const initialState: IFormState = {
  displayName: '',
  id: '',
  milestoneId: '',
  typeId: '',
  areaId: '',
  subAreaId: ''
};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      displayName: {
        label: 'Display name',
        type: 'text'
      },
      id: {
        label: 'Id',
        type: 'text'
      },
      milestoneId: {
        label: 'Milestone',
        type: 'text'
      },
      typeId: {
        label: 'Type id',
        type: 'text'
      },
      areaId: {
        label: 'Area',
        type: 'text'
      },
      subAreaId: {
        label: 'SubArea',
        type: 'text'
      }
    }
  });

  const { data, loading, called } = useQuery(id);


  useEffect(() => {
    if (formState.id === '' && data.id !== '' && !loading && called) {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          ...data
        }
      });
    }
  }, [
    called,
    data,
    dispatch,
    formState,
    loading
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useSaveStandardAreaInstallation() {
  const [
    fnMutate,
    tuple
  ] = useSaveStandardAreaInstallationMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: SaveStandardAreaInstallation_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}


export interface IData extends IFormState {}

export function useQuery(id: string) {
  const tuple = useStandardAreaInstallationFormQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        areaId: tuple.data?.standardAreaInstallation?.area.id ?? '',
        displayName: tuple.data?.standardAreaInstallation?.displayName ?? '',
        id: tuple.data?.standardAreaInstallation?.id ?? '',
        subAreaId: tuple.data?.standardAreaInstallation?.subArea.id ?? '',
        milestoneId: tuple.data?.standardAreaInstallation?.milestone?.id ?? '',
        typeId: tuple.data?.standardAreaInstallation?.type.id ?? ''

      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
